import { render } from "./AboutHero.vue?vue&type=template&id=446b8859&scoped=true"
const script = {}

import "./AboutHero.vue?vue&type=style&index=0&id=446b8859&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446b8859"]])

export default __exports__